export default __webpack_public_path__ + "static/buju-7ed3a371c677c25f759e1f2603e35bde.png";